import React, { useEffect, useState } from "react";
import "./styles.css";
import { Grid, Segment, Divider } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
import { getCurrency } from "../../../../../../redux/actions/currencySelect";

const { Row, Column } = Grid;
const InvoiceDetails = ({
  shippingCost,
  step,
  currencySelect,
  customizationCost,
  getCurrency,
  subtotal,
  discount,
  total,
  totalUSD,
  usdSubTotal,
  formInfo,
  setCurrency,
}) => {
  const [currencyValue, setCurrencyValue] = useState(0);
  const discountAmount = discount ? subtotal * discount : 0;
  useEffect(() => {
    getCurrency();
  }, [getCurrency]);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      setCurrencyValue(currencySelect.currency.currencyLayer);
      setCurrency(currencySelect);
    } else {
      setCurrencyValue(0);
    }
  }, [currencySelect, setCurrency]);
  return (
    <Segment>
      <div className="invoice-details-container">
        {step === 0 && (
          <p className="invoice-details-message text-center">
            El costo de envío será calculado en el siguiente paso
          </p>
        )}

        {step === 1 && formInfo.department.value === "" && (
          <p className="invoice-details-message">
            Complete el formulario para saber el costo de envío
          </p>
        )}

        <Grid padded>
          <Row>
            <Column width={5} textAlign="right">
              <p className="invoice-details-subtext">
                Costo de personalización:
              </p>
            </Column>
            <Column width={11} textAlign="right">
              <p className="invoice-details-subtext">
                {!currencySelect || currencySelect.loading
                  ? "Cargando..."
                  : currencyValue === 0
                  ? formatCurrency(customizationCost)
                  : formatterUSD.format(customizationCost)}
              </p>
            </Column>
          </Row>
          <Row>
            {/* <Column width={2}><Icon name="plus" size="tiny" /></Column> */}
            <Column width={5} textAlign="right">
              <p className="invoice-details-subtext">Subtotal:</p>
            </Column>
            <Column width={11} textAlign="right">
              <p className="invoice-details-subtext">
                {!currencySelect || currencySelect.loading
                  ? "Cargando..."
                  : currencyValue === 0
                  ? formatCurrency(subtotal)
                  : formatterUSD.format(usdSubTotal ? usdSubTotal : subtotal)}
              </p>
            </Column>
          </Row>
          <Row>
            {/* <Column width={2}><Icon name="plus" size="tiny" /></Column> */}
            <Column width={5} textAlign="right">
              <p className="invoice-details-subtext">Costo de envío:</p>
            </Column>
            <Column width={11} textAlign="right">
              {step === 0 && (
                <p className="invoice-details-subtext">
                  {!currencySelect || currencySelect.loading
                    ? "Cargando..."
                    : currencyValue === 0
                    ? formatCurrency(0)
                    : formatterUSD.format(0 / currencyValue.data.value)}
                </p>
              )}
              {step >= 1 && (
                <p className="invoice-details-subtext">
                  {!currencySelect || currencySelect.loading
                    ? "Cargando..."
                    : currencyValue === 0
                    ? formatCurrency(shippingCost)
                    : formatterUSD.format(
                        shippingCost / currencyValue.data.value
                      )}
                </p>
              )}
            </Column>
          </Row>
          {discountAmount !== 0 && (
            <Row>
              {/* <Column width={2}>
                <Icon name="minus" size="tiny" />
              </Column> */}
              <Column width={5} textAlign="right">
                <p className="invoice-details-subtext">Descuento:</p>
              </Column>
              <Column width={11} textAlign="right">
                <p className="invoice-details-subtext">
                  {!currencySelect || currencySelect.loading
                    ? "Cargando..."
                    : currencyValue === 0
                    ? formatCurrency(discountAmount)
                    : formatterUSD.format(
                        discountAmount / currencyValue.data.value
                      )}
                </p>
              </Column>
            </Row>
          )}
          <Divider />

          <Row>
            {/* <Column width={2} /> */}
            <Column width={5} textAlign="right">
              <p className="invoice-details-text">Total:</p>
            </Column>
            <Column width={11} textAlign="right">
              <p className="invoice-details-text">
                {!currencySelect || currencySelect.loading
                  ? "Cargando..."
                  : currencyValue === 0
                  ? formatCurrency(total)
                  : formatterUSD.format(totalUSD ? totalUSD : total)}
              </p>
            </Column>
          </Row>
        </Grid>
      </div>
      {(currencyValue
        ? currencyValue.data.name
          ? currencyValue.data.name
          : false
        : false) && (
        <p className="total-shippingcost-msg-dollar">
          Al seleccionar el tipo de moneda en dólares, el monto total mostrado
          podría discrepar del cobrado por el banco.
        </p>
      )}
    </Segment>
  );
};
const mapStateToProps = (state) => {
  return {
    currencySelect: state.currencySelect,
  };
};

export default connect(mapStateToProps, { getCurrency })(InvoiceDetails);
